export const SERVICE_ID = process.env.REACT_APP_EMAIL_SERVICE_ID
export const TEMPLATE_ID = process.env.REACT_APP_EMAIL_TEMPLATE_ID
export const PUBLIC_KEY = process.env.REACT_APP_EMAIL_PUBLIC_KEY
